import React, { createContext, useContext } from 'react';

const ClientFormUnsavedChangesContext = createContext(null);
const noUnsavedChanges = {
    confirmNavigation: async () => true,
    consumeConfirmedLeaveWithoutSaving: () => false,
    clearUnsavedChanges: () => {},
};

export const ClientFormUnsavedChangesProvider = ({ value, children }) => (
    <ClientFormUnsavedChangesContext.Provider value={value}>
        {children}
    </ClientFormUnsavedChangesContext.Provider>
);

export const useClientFormUnsavedChanges = () => {
    const context = useContext(ClientFormUnsavedChangesContext);

    return context || noUnsavedChanges;
};
